import {Media} from './media';
import {EntitiesList} from './common/entitiesList';

export type ChatMessage = {
    pk: string
    created_at: string
    chat: string
    author: string
    seen_by: Array<string>
    text: string
    msg_type: number
    important: boolean
    replied_to: ReplyToMessage | null
    media: Array<Media>
}

export type ReplyToMessage = {
    pk: string
    author: string
    author_name: string
    text: string
    msg_type: number
    important: boolean
    media: Array<Media>
}

export interface ChatMessagesListResponse extends EntitiesList {
    results: Array<ChatMessage>
}

export type ChatMessageForWS = {
    message_id: string
    created_at: string
    msg_type: number
    reader_id: string
    important: boolean
    chat_status_type: number
    sender: string
    author_id?: string // То же что и sender
    text: string
    replied_to: ChatMessageForWS
    media: Array<Media>
}

export interface UnreadMessagesBulkInfoResponseData {
    chat: string
    claim: string
    unread_messages: number
}

export enum MessageTypeEnum {
    USER = 0,
    TRAVEL_MANAGER_ASSIGNED = 1,
    TRAVEL_MANAGER_REQUESTED_TRIP_CONFIRMATION = 2,
    TRIP_FINALIZED = 3,
    CONFIRMATION_DECLINED = 4,
    BACKEND = 5,
    CLAIM_CONFIRMATION_REQUEST_SENT = 6
}
